import { gql } from "@apollo/client";

export const GET_SUPPLIER_FOR_REGISTRATION = gql`
  query GET_SUPPLIER_FOR_REGISTRATION($id: ID!) {
    supplierForRegister(id: $id) {
      id
      state
      nickName
      draftData
    }
  }
`;

export const SUBMIT_NEW_SUPPLIER_FORM = gql`
  mutation SUBMIT_NEW_SUPPLIER_FORM($draftData: String!) {
    submitNewSupplierForm(draftData: $draftData) {
      supplier {
        id
        state
      }
    }
  }
`;

export const SUBMIT_LONG_TERM_FORM = gql`
  mutation SUBMIT_LONG_TERM_FORM($id: ID!) {
    submitLongTermForm(id: $id) {
      supplier {
        id
        state
      }
    }
  }
`;

export const SUPPLIER_SAVE_DRAFT = gql`
  mutation SUPPLIER_SAVE_DRAFT($draftData: String!) {
    supplierSaveDraft(draftData: $draftData) {
      supplier {
        id
      }
    }
  }
`;
